import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const XTextField = ({ text, emptyBox, copy = true, short = false, sx = {} }: { text: string, emptyBox?: boolean, copy?: boolean, short?: boolean, sx?: object }) => {
  const [copied, setCopied] = useState(false);

  if (!text) {
    if (emptyBox) {
      return <Box sx={sx} />;
    }
    return null;
  }

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  }

  return (
    <Box display="flex" alignItems="center" justifyContent='space-between' sx={sx}>
      <Tooltip title={text}>
        <Typography variant='body2' noWrap>{short ? `${text.slice(0, 8)}...${text.slice(-4)}` : text}</Typography>
      </Tooltip>
      {copy && (
        <Tooltip title={copied ? "Copied!" : "Copy"}>
          <IconButton size="small" onClick={handleCopy}>
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default XTextField;
